import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Buefy from 'buefy'
import '@/styles/styles.scss'
import {setDomain} from './api/backend'
import {setDomain as setDomainPortal} from './api/portal'
import authInterceptor from './api/auth-interceptor'
import moment from 'moment'
import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
} from 'vee-validate'
import {
  required,
  email,
  numeric,
  oneOf,
  min,
  confirmed,
} from 'vee-validate/dist/rules'
import de from 'vee-validate/dist/locale/de'
import './filters/currency-filter'
import './filters/amount-filter'

setDomain(process.env.VUE_APP_API)
setDomainPortal('https://portal.srv.urlaubsgutschein.kaufen')
authInterceptor()
Vue.config.productionTip = false

Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultTooltipAnimated: true,
  defaultDayNames: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  defaultMonthNames: [
    'Jan',
    'Feb',
    'Mär',
    'Apr',
    'Mai',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dez',
  ],
  defaultFirstDayOfWeek: 1,
})

Vue.use(VueObserveVisibility)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

localize('de', de)
extend('required', {
  ...required,
  message: de.messages['required'],
})
extend('email', {
  ...email,
  message: de.messages['email'],
})
extend('numeric', {
  ...numeric,
  message: de.messages['numeric'],
})
extend('oneOf', {
  ...oneOf,
  message: de.messages['oneOf'],
})

extend('min', {
  ...min,
  message: de.messages['min'],
})

extend('confirmed', {
  ...confirmed,
  message: de.messages['confirmed'],
})

extend('filename', {
  validate: value => value.match(/^[\w.-]+$/), // the validation function
  message: 'Der Name darf keine Leer oder Sonderzeichen beeinhalten.', // the error message
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY HH:mm')
  }
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
